module.exports = __webpack_public_path__ + "static/media/takeaway_outline_color.34e65069.svg";